import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {  ModalLumPeriodComponent} from 'src/app/components/ui/modal-lum-period/modal-lum-period.component';
import { DeviceService } from 'src/app/services/devices/device.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import {
  findFreeLumPeriodId,
  formatLumPeriodRange,
  getLumPeriodBadgeClass,
} from 'src/app/services/LUM/lum.helper';

export const MAX_PERIODS = 6;

@Component({
  selector: 'app-lum-scheduler-periods',
  imports: [CommonModule, TranslateModule],
  templateUrl: './lum-scheduler-periods.component.html',
  styleUrl: './lum-scheduler-periods.component.scss',
})
export class LumSchedulerPeriodsComponent implements OnChanges {

  @Input() device = '';
  @Input() schedulerData: any = null;

  @Output() periodsChanged = new EventEmitter<void>();



  periods: any[] = [];
  loading = false;

  constructor(private _modal: ModalService, private _device: DeviceService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['schedulerData']) {
      this.periods = JSON.parse(this.schedulerData?.cfg?.periods);
    }
  }

  openPeriodModal(period: any | null = null): void {
    if (!period && !this.canAddPeriod) {
      return;
    }

    const modalRef = this._modal.open(ModalLumPeriodComponent, {
      centered: true,
      size: 'xl',
      scrollable: false,
      windowClass: 'scheduler-window lum-period-modal',
    });

    modalRef.componentInstance.period = period;

    modalRef.result.then(
      (saved) => {
        delete saved.scheduleMode;
        delete saved.startTimeStr;
        delete saved.endTimeStr;

        const savedId = Number(saved.id);
        const isEdit =
          Number.isFinite(savedId) &&
          savedId >= 1 &&
          savedId <= MAX_PERIODS &&
          this.periods.some((item) => Number(item.id) === savedId);
        if (isEdit) {
          const index = this.periods.findIndex((item) => Number(item.id) === savedId);
          if (index >= 0) {
            this.periods[index] = saved;
          }
        } else {
          const freeId = this.findIdFree();
          if (freeId == null) {
            return;
          }
          saved.id = freeId;
          this.periods = [...this.periods, saved];
        }

        this.savePeriods();
      },
      () => {},
    );
  }

  /** Primer id libre entre 1 y MAX_PERIODS en la lista actual. */
  findIdFree(): number | null {
    return findFreeLumPeriodId(this.periods, MAX_PERIODS);
  }

  deletePeriod(period: any): void {
    this.loading = true;
    this._device.deleteCollection(this.device, 'scheduler', 'periods', period.id).subscribe({
      next: () => {
        this.periodsChanged.emit();
      },
      error: (err) => console.error('Error al eliminar periodo LUM:', err),
      complete: () => this.loading = false,
    });  }


  savePeriods(): void {
    this.loading = true;
    this._device.setModuleCfg(this.device, { periods: this.periods }, 'scheduler').subscribe({
      next: () => this.periodsChanged.emit(),
      error: (err) => console.error('Error al guardar periodos LUM:', err),
      complete: () => this.loading = false,
    });
  }

  togglePeriodEnabled(period: any): void {
    period.enabled = !period.enabled;
    this.savePeriods();
  }


  getMaxPeriods(): number {
    return MAX_PERIODS;
  }

  canAddPeriod(): boolean {
    return this.periods.length < MAX_PERIODS;
  }

  getPeriodBadgeClass(periodId: number): string {
    return getLumPeriodBadgeClass(periodId);
  }

  formatRange(period: any): string {
    return formatLumPeriodRange(period);
  }
}
